import React from 'react';
import PropTypes from 'prop-types';
import HeroItem from '../molecules/HeroItem';
import HeroTitle from '../molecules/HeroTitle';

function HeaderContactUs({ heroMedia, isLoading }) {
  return (
    <header className="relative h-[50vh] md:h-screen">
      <HeroItem video={heroMedia} isLoading={isLoading} />
      <HeroTitle title="CONTACT US" />
    </header>
  );
}

HeaderContactUs.propTypes = {
  heroMedia: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

HeaderContactUs.defaultProps = {
  isLoading: null,
};

export default HeaderContactUs;
